import React from "react";
import AsyncSelect from "react-select/async";

import { addCascadingEvent } from "../../../../util/Functions";
import ApiKeyContext from "../../../../contexts/ApiKeyContext";
import ApiDrivenModel from "../../../../models/ApiDrivenModel";

import FormBuilderInputAutolookupOption from "./FormBuilderInputAutolookupOption";

export default function FormBuilderInputAutolookup({ innerRef, ...props }) {
	const [value, setValue] = React.useState(
		props.value !== undefined ? props.value + "" : ""
	);
	const [searchOptions, setSearchOptions] = React.useState([
		"",
		"" + props.value,
	]);
	const [textLabel, setTextLabel] = React.useState(false);

	const API_KEY_CONTEXT = React.useContext(ApiKeyContext);
	const searchParams = {
		endpoint: "/" + props.object,
		class: props.object,
		paths: { id: true },
		limit: 20,
		meta: true,
	};

	/**
	 * This function is called initially to fetch initial data.
	 * callback parameter only exists if this function is called within
	 * <AsyncSelect loadOptions/>
	 * @param {string} inputValue
	 * @param {function} callback
	 */
	const getOptions = (search, callback) => {
		// TODO: Add to this map later on
		const searchFields = {
			Item: ['common_sku']
		};

		const params = { ...searchParams };
		if (searchFields[props.object]) {
			params.filters = props.filters ? [].concat(props.filters) : [];
			params.filters.push(
				searchFields[props.object].map(p => ({
					property: `{${p}}`,
					comparison: 'LIKE',
					value: `${search}%`
				}))
			);
		} else {
			params.search = search;
		}
		addCascadingEvent(
			"autoLookupSearch",
			() => {
				ApiDrivenModel.Search(API_KEY_CONTEXT, params)
					.then((result) => {
						let opts = result.map((r) => r._meta);
						callback ? callback(opts) : setSearchOptions(opts);
					});
			},
			300
		);
		setSearchOptions([]);
	};
	const onChangeHandler = ({ id }) => {
		props.onChange && props.onChange({ target: { value: id } });
	};

	const renderOption = (props, option) => (
		<FormBuilderInputAutolookupOption key={parseValue(option)} props={props} option={option} />
	);

	const fetchLabel = (id) =>
		ApiDrivenModel.Fetch(API_KEY_CONTEXT, {
			...searchParams,
			filter: JSON.stringify({ id }),
		}).then((result) => {
			setTextLabel(renderOption({}, result?._meta));
			setSearchOptions([result?._meta]);
		});

	// Load initial label
	props.value && !textLabel && fetchLabel(props.value?.id ? props.value.id : props.value);
	const formatOptionLabel = (option) => renderOption(props, option);

	const parseValue = (option) => {
		option = option?.id ? option.id : option;
		return option ? option + "" : "";
	};

	const inputOptions = {};
	Object.keys(props)
		.filter((key) => ["value"].includes(key))
		.forEach((key) => (inputOptions[key] = props[key]));

	React.useEffect(() => {
		fetchLabel(value?.id ? value.id : value);
	}, [value]);

	return (
		<>
			<label>{props.label}</label>

			<AsyncSelect
				ref={props.innerRef}
				menuPlacement="auto"
				className={(!textLabel && props.value && "loading") || ""}
				placeholder={textLabel || (props.value ? "Loading..." : "")}
				getOptionLabel={option => renderOption({}, option)}
				formatOptionLabel={formatOptionLabel}
				getOptionValue={parseValue}
				loadOptions={getOptions}
				onChange={onChangeHandler}
				defaultOptions={true}
				isDisabled={props.disabled}
				required={props.required}
				noOptionsMessage={() =>
					`No results found for '${textLabel}', try entering more words`
				}
				loadingMessage={() => "Loading..."}
			/>
		</>
	);
}
